module.exports = __webpack_public_path__ + "img/wosho@2x.5034b3e6.png";